module.exports = __webpack_public_path__ + "static/media/iStock-475702355.ae38195e.jpg";